/**
 * Maps i18n language codes to Google reCAPTCHA language codes
 * @param language - The i18n language code
 * @returns The corresponding reCAPTCHA language code
 */
export const getRecaptchaLanguage = (language: string): string => {
  switch (language) {
    case 'es-us':
      return 'es-419'; // Spanish (Latin America)
    case 'fr-ca':
      return 'fr-CA'; // French (Canadian)
    default:
      return language; // de, en, es, fr, it, nl, pt all match directly
  }
};
